// @flow
import type { ComponentType } from 'react';
import React from 'react';
import {
  SortableContainer,
  SortableElement,
} from 'react-sortable-hoc';

import styles from './sortableList.css';


type SortableListPropTypes = {
  items: Array<Object>,
  className?: string,
  ItemComponent?: ComponentType<*>,
  EmptyListComponent: ComponentType<*>,
  hasHandle?: boolean
};

type SortableListStateTypes = {
  SortableItemComponent: ComponentType<*>
};

class SortableListDummy extends React.Component<SortableListPropTypes, SortableListStateTypes> {
  constructor(props: SortableListPropTypes) {
    super(props);
    const { ItemComponent } = props;

    this.state = {
      SortableItemComponent: SortableElement(ItemComponent),
    };
  }

  render() {
    const {
      className,
      EmptyListComponent,
      items = [],
      hasHandle = false,
      ...props
    } = this.props;
    const { SortableItemComponent } = this.state;

    return (
      <div className={
        `
          ${styles.sortableList}
          ${typeof className !== 'undefined' ? className : ''}
        `
      }
      >
        { items && items.length === 0 && <EmptyListComponent /> }
        {
          items && items.length > 0 && SortableItemComponent && (
            items.map((item, index) => (
              <SortableItemComponent
                key={`item-${index}`} // eslint-disable-line react/no-array-index-key
                index={index}
                hasHandle={hasHandle}
                {...item}
                {...props}
              />
            ))
          )
        }
      </div>
    );
  }
}

const SortableList = SortableContainer(SortableListDummy);

export default SortableList;



// WEBPACK FOOTER //
// ./src/scripts/components/SortableList/index.jsx